import { render, staticRenderFns } from "./kyTj.vue?vue&type=template&id=7bdfd30c&scoped=true&"
import script from "./kyTj.vue?vue&type=script&lang=js&"
export * from "./kyTj.vue?vue&type=script&lang=js&"
import style0 from "./kyTj.vue?vue&type=style&index=0&id=7bdfd30c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfd30c",
  null
  
)

export default component.exports